// localBackup.js - Lokales Backup aller Einträge pro Gerät
// Speichert jeden erstellten/bearbeiteten/gelöschten Eintrag im localStorage

const getBackupKey = (tenant, mitid) => `backup_entries_${tenant}_${mitid}`;

/**
 * Eintrag im lokalen Backup speichern
 */
export const saveEntryToBackup = (tenant, mitid, entry, action) => {
  try {
    const key = getBackupKey(tenant, mitid);
    const existing = JSON.parse(localStorage.getItem(key) || '[]');

    existing.push({
      action,
      timestamp: new Date().toISOString(),
      tenant,
      entry
    });

    localStorage.setItem(key, JSON.stringify(existing));
  } catch (err) {
    console.error('Backup-Fehler:', err);
  }
};

/**
 * Alle Backup-Einträge eines Benutzers lesen
 */
export const getBackupEntries = (tenant, mitid) => {
  try {
    const key = getBackupKey(tenant, mitid);
    return JSON.parse(localStorage.getItem(key) || '[]');
  } catch (err) {
    console.error('Backup-Lesefehler:', err);
    return [];
  }
};

/**
 * CSV-Inhalt aus Backup generieren
 */
const buildBackupCSV = (entries) => {
  const header = 'Aktion;Zeitstempel;Tenant;StuWebID;Datum;Anzahl;Beschrieb;AufIDRef;SarIDRef;Verrechnet;Zuschlag';
  const rows = entries.map(b => {
    const e = b.entry || {};
    return [
      b.action,
      b.timestamp,
      b.tenant,
      e.stuwebid || e.StuPGID || '',
      e.studatum || e.StuDatum || '',
      e.stuanzahl || e.StuAnzahl || '',
      `"${(e.stubeschrieb || e.StuBeschrieb || '').replace(/"/g, '""')}"`,
      e.stuaufidref || e.StuAufIDRef || '',
      e.stusaridref || e.StuSarIDRef || '',
      e.stuverrechnet || e.StuVerrechnet || false,
      e.stuzuschlag || e.StuZuschlag || 0
    ].join(';');
  });

  return '\uFEFF' + header + '\n' + rows.join('\n');
};

/**
 * Backup als CSV exportieren und herunterladen
 */
export const exportBackupAsCSV = (tenant, mitid) => {
  const entries = getBackupEntries(tenant, mitid);
  if (entries.length === 0) {
    alert('Keine Backup-Einträge vorhanden.');
    return;
  }

  const csv = buildBackupCSV(entries);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `backup_${tenant}_${mitid}_${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};

/**
 * Backup teilen (Web Share API) oder als Fallback herunterladen
 */
export const shareBackup = async (tenant, mitid) => {
  const entries = getBackupEntries(tenant, mitid);
  if (entries.length === 0) {
    alert('Keine Backup-Einträge vorhanden.');
    return;
  }

  const filename = `backup_${tenant}_${mitid}_${new Date().toISOString().split('T')[0]}.csv`;
  const csv = buildBackupCSV(entries);
  const file = new File([csv], filename, { type: 'text/csv' });

  // Web Share API mit Datei-Sharing (Mobile)
  if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({
        title: `Stundenbackup ${tenant}`,
        text: `${entries.length} Backup-Einträge`,
        files: [file]
      });
      return;
    } catch (err) {
      if (err.name === 'AbortError') return; // Benutzer hat abgebrochen
      console.warn('Share fehlgeschlagen, Fallback auf Download:', err);
    }
  }

  // Fallback: CSV herunterladen
  exportBackupAsCSV(tenant, mitid);
};
